module.exports = __webpack_public_path__ + "static/media/alternator-stering-and-replacement.7b55f786.svg";